import { render, staticRenderFns } from "./add-coupon-pop.vue?vue&type=template&id=31fb983a&scoped=true&"
import script from "./add-coupon-pop.vue?vue&type=script&lang=js&"
export * from "./add-coupon-pop.vue?vue&type=script&lang=js&"
import style0 from "./add-coupon-pop.vue?vue&type=style&index=0&id=31fb983a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fb983a",
  null
  
)

export default component.exports